<template>
  <div>
    <dl class="row mb-0">
      <dt class="col-sm-12">Leads Notes</dt>
    </dl>
    <div class="accordion" role="tablist" v-if="getSortedArray.length > 0">
      <div v-for="(item, index) in getSortedArray" :key="index">
        <template>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button
                block
                href="#"
                v-b-toggle="'accordion-' + index"
                variant="secondary"
                class="text-left pb-1 pt-1"
              >
                {{ item.created_at | dateConvertDDMMYYYYTime }}
              </b-button>
            </b-card-header>
            <b-collapse
              :id="'accordion-' + index"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <p class="mb-0" v-html="item.note"></p>
              </b-card-body>
            </b-collapse>
          </b-card>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'WDVsaLeadsNotes',
  props: {
    leadsNote: {
      type: Array,
      default: []
    }
  },
  computed: {
    /**
     * Remove mutates of data
     */
    getSortedArray() {
      let leadsNote = this.leadsNote
      let removeMutate = JSON.parse(JSON.stringify(leadsNote))
      return removeMutate.reverse()
    }
  }
}
</script>
